import { useAppSelector, useTranslate } from 'hooks';

import { selectUser } from 'selectors';

import { SettingsDisabledInput } from './SettingsDisabledInput';
import { SettingsCard } from './SettingsCard';

import s from './index.module.scss';
import classnames from "classnames";

export const SettingsBankAccountCards = () => {
	const t = useTranslate(['bankAccountText', 'bankAccountsText']);
	const user = useAppSelector(selectUser);

	return (
		<SettingsCard title={t.bankAccountsText}>
			<div className={s.rateGroup}>
				{user.accounts.map((item) => {
					return (
						<div key={item.id} className={s.rateRow}>
							<SettingsDisabledInput
								className={classnames(s.col, s.inputMaxWith312)}
								name={t.bankAccountText}
								value={item.account}
							/>
						</div>
					);
				})}
			</div>
		</SettingsCard>
	);
};
